import { ArrowRight, ShieldCheck, Zap } from "lucide-react";
import { CHECKOUT_URL, MEDIA } from "@/lib/constants";

export default function Hero() {
    return (
        <section
            id="hero"
            data-testid="section-hero"
            className="relative overflow-hidden bg-cream"
        >
            <div className="absolute inset-0 grain pointer-events-none" />
            <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 pt-16 pb-20 lg:pt-24 lg:pb-32">
                <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
                    {/* Left: Copy */}
                    <div className="lg:col-span-7 reveal">
                        <div className="flex items-center gap-3 mb-6">
                            <span className="hairline w-10" />
                            <span className="label-eyebrow">
                                Método dos Poliglotas
                            </span>
                        </div>
                        <h1 className="font-serif text-emerald-brand text-[2.5rem] leading-[1.05] sm:text-5xl lg:text-[4.25rem] lg:leading-[1.02] tracking-tight">
                            Você não precisa
                            <span className="italic text-gold-brand">
                                {" "}
                                estudar mais{" "}
                            </span>
                            inglês.
                            <br className="hidden sm:block" />
                            Você precisa
                            <span className="italic"> destravar </span>
                            o que já sabe.
                        </h1>
                        <p className="mt-7 text-lg lg:text-xl text-emerald-light/90 max-w-2xl leading-relaxed">
                            Um método prático de 30 dias, baseado nas técnicas
                            que poliglotas usam para sair do travamento e
                            finalmente <strong>falar</strong> — mesmo que você
                            já tenha tentado curso, app e aula particular.
                        </p>

                        <div className="mt-10 flex flex-col sm:flex-row sm:items-center gap-4">
                            <a
                                href={CHECKOUT_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="cta-hero"
                                className="btn-gold pulse-gold text-base sm:text-lg"
                            >
                                Quero destravar meu inglês
                                <ArrowRight className="w-5 h-5" />
                            </a>
                            <a
                                href="#oferta"
                                data-testid="cta-hero-secondary"
                                className="text-emerald-brand font-semibold underline-offset-4 hover:underline inline-flex items-center gap-2"
                            >
                                Ver o que está incluso
                            </a>
                        </div>

                        <div className="mt-10 flex items-center gap-5 flex-wrap">
                            <div className="flex items-center gap-2 text-sm text-emerald-light/80">
                                <ShieldCheck className="w-4 h-4 text-gold-brand" />
                                Garantia incondicional de 7 dias
                            </div>
                            <div className="flex items-center gap-2 text-sm text-emerald-light/80">
                                <Zap className="w-4 h-4 text-gold-brand" />
                                Acesso imediato por e-mail
                            </div>
                        </div>
                    </div>

                    {/* Right: E-book Cover */}
                    <div className="lg:col-span-5 reveal relative">
                        <div className="relative aspect-square flex items-center justify-center">
                            <div className="absolute inset-0 bg-gradient-to-br from-gold-brand/25 via-transparent to-emerald-brand/15 rounded-[3rem] blur-3xl" />
                            <img
                                src={MEDIA.ebookMockup}
                                alt="E-book Inglês Destravado em 30 Dias"
                                className="relative w-full max-w-md ebook-float rounded-2xl shadow-2xl ring-1 ring-black/10"
                                data-testid="hero-ebook-image"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
